import { render, staticRenderFns } from "./feather_icon.vue?vue&type=template&id=3d2e4e78"
import script from "./feather_icon.vue?vue&type=script&lang=js"
export * from "./feather_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports